// import jwt_decode from "jwt-decode";

// export function setupAutoLogout(token, logoutFn) {
//   if (!token) return;

//   try {
//     const decoded = jwt_decode(token);
//     const expirationTime = decoded.exp * 1000; 
//     const currentTime = Date.now();
//     const timeLeft = expirationTime - currentTime;

//     if (timeLeft <= 0) {
//       logoutFn(); 
//     } else {
//       setTimeout(() => {
//         logoutFn(); 
//       }, timeLeft);
//     }
//   } catch (err) {
//     console.error("Invalid token", err);
//     logoutFn(); 
//   }
// }


import { jwtDecode } from "jwt-decode";

export function setupAutoLogout(token, logoutFn) {
  if (!token) return;

  try {
    const decoded = jwtDecode(token);
    const expirationTime = decoded.exp * 1000; 
    const currentTime = Date.now();
    const timeLeft = expirationTime - currentTime;

    if (timeLeft <= 0) {
      logoutFn(); 
    } else {
      setTimeout(() => {
        logoutFn(); 
      }, timeLeft);
    }
  } catch (err) {
    console.error("Invalid token", err);
    logoutFn(); 
  }
}
